import {
  TARF_INIT_LOADING,
  TARF_INIT_SUCCESS,
  TARF_INIT_FAIL,
  TARF_BENEFIT_LOADING,
  TARF_BENEFIT_SUCCESS,
  TARF_BENEFIT_FAIL,
  TARF_FACTOR_LOADING,
  TARF_FACTOR_SUCCESS,
  TARF_FACTOR_FAIL
} from '@/store/types'

export const tariff = {
  [TARF_INIT_LOADING](state) {
    state.tariff.init = 0
    state.tariff.initErr = []
    state.tariff.menu = {}
  },
  [TARF_INIT_SUCCESS](state, data) {
    state.tariff.init = 1
    state.tariff.initErr = []
    state.tariff.menu = data.menu
  },
  [TARF_INIT_FAIL](state, error) {
    state.tariff.init = 2
    state.tariff.initErr = error
    state.tariff.menu = {}
  },
  [TARF_BENEFIT_LOADING](state) {
    state.tariff.benefit.init = 0
    state.tariff.benefit.initErr = []
    state.tariff.benefit.menu = {}
  },
  [TARF_BENEFIT_SUCCESS](state, data) {
    state.tariff.benefit.init = 1
    state.tariff.benefit.initErr = []
    state.tariff.benefit.menu = data.menu
  },
  [TARF_BENEFIT_FAIL](state, error) {
    state.tariff.benefit.init = 2
    state.tariff.benefit.initErr = error
    state.tariff.benefit.menu = {}
  },
  [TARF_FACTOR_LOADING](state) {
    state.tariff.factor.init = 0
    state.tariff.factor.initErr = []
    state.tariff.factor.menu = {}
  },
  [TARF_FACTOR_SUCCESS](state, data) {
    state.tariff.factor.init = 1
    state.tariff.factor.initErr = []
    state.tariff.factor.menu = data.menu
  },
  [TARF_FACTOR_FAIL](state, error) {
    state.tariff.factor.init = 2
    state.tariff.factor.initErr = error
    state.tariff.factor.menu = {}
  }
}
